import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#007eee",
    },
    secondary: {
      main: "#ff6600",
    },
    info: {
      main: "#fff",
    },
    background: {
      default: "#25262C",
      paper: "#25262C",
    },
    text: {
      primary: "#fff",
    },
  },
  typography: {
    fontFamily: "Signika",
  },
});
theme.typography.h1 = {
  fontSize: "24px",
  [theme.breakpoints.up("md")]: {
    fontSize: "40px",
  },
};

theme.typography.h3 = {
  fontSize: "18px",
  [theme.breakpoints.up("md")]: {
    fontSize: "24px",
  },
};

theme.typography.h6 = {
  fontSize: "16px",
  [theme.breakpoints.up("md")]: {
    fontSize: "18px",
  },
};

theme.typography.body1 = {
  fontSize: "20px",
  fontWeight: 400,
  [theme.breakpoints.up("md")]: {
    fontSize: "24px",
  },
};
theme.typography.body2 = {
  fontSize: "16px",
  fontWeight: 400,
  [theme.breakpoints.up("md")]: {
    fontSize: "20px",
  },
};

theme.components.MuiButton = {
  styleOverrides: {
    root: {
      textTransform: "none",
      borderRadius: "30px",
      fontSize: "18px",
      fontWeight: 400,
      padding: "5px 20px",
      [theme.breakpoints.up("md")]: {
        fontSize: "24px",
      },
    },
  },
};

export default theme;
